(function() { module.exports = this["wp"]["wordcount"]; }());